/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/Dashboard.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const Dashboard: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18" ref={ref} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M11.26 5.68 15.978.96a.75.75 0 0 1 1.06 1.061l-5.25 5.25a.75.75 0 0 1-1.06 0l-3.97-3.97-4.72 4.72a.75.75 0 1 1-1.06-1.06l5.25-5.25a.75.75 0 0 1 1.06 0zM7.883 8.24h-2.25a.375.375 0 0 0-.375.376v8.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-8.25a.375.375 0 0 0-.375-.375m-4.5 5.25h-2.25a.375.375 0 0 0-.375.376v3c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375m6.75 0h2.25c.207 0 .375.169.375.376v3a.375.375 0 0 1-.375.375h-2.25a.375.375 0 0 1-.375-.375v-3c0-.207.168-.375.375-.375m6.75-5.25h-2.25a.375.375 0 0 0-.375.376v8.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-8.25a.375.375 0 0 0-.375-.375"
      clipRule="evenodd"
    />
  </svg>
);
Dashboard.displayName = "Dashboard";
